module.exports = __webpack_public_path__ + "media/images/buriel-9-aeacd9f946322a43a2c265dfd8cf79fd.png";